import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private readonly baseUrl: string = `${environment.apiUrl}/OPRAG/v0/endpoint`;



  constructor(private httpClient: HttpClient) { }

  loadData(element: string, page = 0, size = 20) {
    return this.httpClient.get<any>(`${this.baseUrl}/${element}/all?page=${page}&size=${size}`);
  }
  loadLicenceData(element: string, page = 0, size = 20, utilisateurId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/${element}/all/${utilisateurId}?page=${page}&size=${size}`);
  }

  loadDemandeLicenceData(element: string, page = 0, size = 20, utilisateurId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/${element}/all/${utilisateurId}?page=${page}&size=${size}`);
  }


  // Nouvelle méthode pour récupérer TOUTES les données pour l'export Excel
  getAllCertificatControlsForExport() {
    // Utiliser une taille très grande pour récupérer toutes les données en une fois
    return this.httpClient.get<any[]>(`${this.baseUrl}/CertificatControls/all?page=0&size=10000`);
  }

  createObject(element: string, obj: any) {
    return this.httpClient.post<any>(`${this.baseUrl}/${element}/create`, obj);
  }

  createReport(reportFormat: string, certificatControl: number) {
    return this.httpClient.post<any>(`${this.baseUrl}/Reports/exportReport/${reportFormat}/${certificatControl}`, null, { responseType: 'blob' as 'json' })
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'inspectionFiche.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
      });

  }

  createCard(cardInfo: any) {
    return this.httpClient.post<any>(`${this.baseUrl}/Reports/exportCard`, cardInfo, { responseType: 'blob' as 'json' })
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'carte.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
      });

  }
  createReportWithNgrx(reportFormat: string, certificatControl: number) {
    return this.httpClient.post<any>(`${this.baseUrl}/Reports/exportReport/${reportFormat}/${certificatControl}`, null, { responseType: 'blob' as 'json' })


  }

  deleteCertificatControl(certificatControlId: number) {
    return this.httpClient.delete(`${this.baseUrl}/CertificatControls/delete/${certificatControlId}`)
  }

  deleteInspectionMontant(inspectionMontantId: number) {
    return this.httpClient.delete(`${this.baseUrl}/InspectionMontant/delete/${inspectionMontantId}`)
  }
  createQrCodeImage(numero: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/getQrCode/${numero}`, { responseType: 'blob' as 'json' })
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'qrCodeImage.png';
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  createQrCodeImageWithNgRx(numero: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/getQrCode/${numero}`, { responseType: 'blob' as 'json' })

  }

  countAllPerDay() {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/countAllPerDay`)
  }

  usersPerInspectionName() {
    return this.httpClient.get<any>(`${this.baseUrl}/Utilisateurs/findAllByInspectionNom`)
  }
  usersPerInspectionNameWithParam(nomInspection: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/Utilisateurs/findAllByInspectionNom/${nomInspection}`)
  }

  findUserById(userId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/Utilisateurs/findById/${userId}`)
  }
  updateUser(user: any) {
    return this.httpClient.post<any>(`${this.baseUrl}/auth/update`, user)
  }
  lastUpdateDate(userId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/Utilisateurs/lastOperationDate/${userId}`)
  }

  loadBadgeReport(inspecteurId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/findAllPerInspecteurId/${inspecteurId}`)
  }
  loadCertificatReport(userId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/CertificatControls/findCertificatControlByUtilisateurId/${userId}`)
  }
  loadInspections() {
    return this.httpClient.get<any>(`${this.baseUrl}/Inspections/all`)
  }

  deleteInspection(inspectionId: number) {
    return this.httpClient.delete<any>(`${this.baseUrl}/Inspections/delete/${inspectionId}`)
  }
  createInspection(inspection: any) {
    return this.httpClient.post<any>(`${this.baseUrl}/Inspections/create`, inspection)
  }
  countAllPerInterval(dateDebut: string, dateFin: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/countAllPerIntervalDays/${dateDebut}/${dateFin}`)
  }
  registerChauffeur(chauffeurRequest: any) {
    return this.httpClient.post<any>(`${this.baseUrl}/Chauffeurs/register`, chauffeurRequest)
  }

  CountBadgeCreated() {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/numberOfBadges`)
  }

  countBadgePerInspecton() {
    return this.httpClient.get<any>(`${this.baseUrl}/Badges/numberOfBadgePerInspection`)
  }
  countRapportCreated() {
    return this.httpClient.get<any>(`${this.baseUrl}/CertificatControls/numberOfCertificatControls`)
  }

  certificatControlsStatsByInspection() {
    return this.httpClient.get<any>(`${this.baseUrl}/CertificatControls/getCertificatControlsStatsByInspection`)
  }

  pieChartData() {
    return this.httpClient.get<any>(`${this.baseUrl}/Inspections/pieChartStatsData`)
  }
  totalCertificatControlsAmount() {
    return this.httpClient.get<any>(`${this.baseUrl}/CertificatControls/certificatControlsAmount`)
  }
  getState(dateDebut = "2025-09-20", dateFin = "2025-09-24", inspectionId: number) {
    return this.httpClient.get<any>(`${this.baseUrl}/Statistiques/${dateDebut}/${dateFin}/${inspectionId}`)
  }
  getStatWithoutInspection(dateDebut: any, dateFin: any) {
    return this.httpClient.get<any>(`${this.baseUrl}/Statistiques/${dateDebut}/${dateFin}`)
  }
  // getStatWithoutInspection(dateDebut: any, dateFin: any) {
  //   return this.httpClient.get<any>(this.baseUrl + ":1020/OPRAG/v0/endpoint/Statistiques/" + dateDebut + "/" + dateFin)
  // }

  changeState(userId: number) {
    return this.httpClient.delete<any>(`${this.baseUrl}/Utilisateurs/changeState/${userId}`)
  }
}
